export const enum ChatLogEntryTypeType {
    TEXT = "text",
    ASSET = "asset",
    LOCATION = "location",
    EVENT = "event",
    INTERNAL_COMMENT = "internalcomment",
}
